module.exports = __webpack_public_path__ + "img/extended.5f6dab9f.png";